import * as types from '../actions/actionTypes'


const notificationsReducer = (state = {
    allNotifications: [],
    allNotificationAnalytics: [],
}, action) => {

    switch(action.type) {
      case types.GET_NOTIFICATIONS_DATA_SUCCESS: 
        state = {
          ...state,
          allNotifications: action.payload,
        };
      break;
      case types.DELETE_NOTIFICATION_FROM_STATE: 
        const notifications = state.allNotifications
        const result = notifications.filter(notificationsObject => notificationsObject.key != action.payload);
        state = {
          ...state,
          allNotifications: result,
        };
      break;
      case types.SET_CURRENT_COMPANY: 
        //if logging in with a different company wipe all of the store 
      state = {
        ...state,
        allNotifications: action.payloadTwo ? state.allNotifications : []
      };
      break;
      case types.GET_NOTIFICATION_ANALYTICS_SUCCESS:
        state = {
          ...state,
          allNotificationAnalytics: action.payload ? action.payload: [],
        };
      break;
      default:
      break;    
    }

    return state;
};


export default notificationsReducer;


// WEBPACK FOOTER //
// ./src/reducers/notificationsReducer.js